import { gql } from '@apollo/client';

export const GET_COLLEGE_LIST = gql`
 query Institutions($institutionSearchInput: InstitutionSearchInput!) {
    institutions(institutionSearchInput: $institutionSearchInput) {
      reportingName
      legalName
      keyValue
      city
      stateProvince
    }
  }
`;

export const VERIFY_CODE = gql`
  query AuthenticateStudentResponse($authenticateStudentInput: AuthenticateStudentInput!) {
    authenticateStudentResponse(authenticateStudentInput: $authenticateStudentInput) {
      code
      token
    }
}
`;

export const GET_CONTACT_INFORMATION = gql`
  query ContactInformation {
    contactInformation {
      streetAddress1
      streetAddress2
      city
      state
      stateCode
      zipCode
      country
    }
  }
`;
